import { render } from "./BackgroundClouds.vue?vue&type=template&id=10f44c06&scoped=true"
import script from "./BackgroundClouds.vue?vue&type=script&lang=js"
export * from "./BackgroundClouds.vue?vue&type=script&lang=js"

import "./BackgroundClouds.vue?vue&type=style&index=0&id=10f44c06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f44c06"]])

export default __exports__